@if (items.length) {
  <div class="item-container">
    @if (videoItems.length) {
      <div class="video-container">
        @for (item of videoItems; track item) {
          <div class="lesson-item video-item">
            <h3>{{ item.title }}</h3>
            <video controls
              (play)="onVideoStarted(item)">
              <source [src]="item.videoData" type="video/mp4">
              Das Video konnte nicht geladen werden
            </video>
          </div>
        }
      </div>
    }
    @for (item of items; track item) {
      @if (item.type.title === LessonPageItemTypeEnum.TEXT) {
        <div class="lesson-item">
          @if (item.title) {
            <h3>{{ item.title }}</h3>
          }
          <p>{{ item.content }}</p>
        </div>
      }
      @if (item.type.title === LessonPageItemTypeEnum.QUIZ) {
        <div class="lesson-item">
          <h3>{{ item.title }}</h3>
          <div class="question-box">
            <div class="question-content">
              {{ item.content }}
            </div>
          </div>
          <div class="quiz-answers">
            @for (answer of item.quiz_answers; track answer; let i = $index) {
              <app-quiz-answer-tile
                [answerText]="answer.answer_text"
                [answerId]="answer.id"
                [isSelected]="selectedAnswers.includes(answer.id)"
                (selectionChange)="toggleAnswerSelection(answer.id)"
              ></app-quiz-answer-tile>
            }
          </div>
          <div class="quiz-button">
            <button (click)="pressAnswerButton()" [disabled]="selectedAnswers.length === 0">Antwort abgeben</button>
          </div>
        </div>
      }
    }
  </div>
}

@if (!items.length) {
  <div>
    <h3>Für diese Lektion konnten keine Elemente geladen werden</h3>
  </div>
}
